export default __webpack_public_path__ + "static/media/BNBbsc.670a4698.png";